import React from 'react';
import { Snackbar } from '@own/fds-react';
import { SnackbarProps } from '@own/fds-react/dist/types/snackbar.types';
import './rides-snackbar.scss';

interface RidesSnackbarProps extends SnackbarProps {
    isError?: boolean;
    snackBarCustomClass?: string;
    dismissibleSnackbarTimer: number;
}

function RidesSnackbar(props: RidesSnackbarProps) {
    const SNACKBAR_DISMISS_TIMER = 7000;
    return (
        <Snackbar
            {...props}
            snackbarClassName={`rides-snackbar ${props.snackBarCustomClass ??
                ''} ${props.isError ? 'error' : ''}`}
            showDismissButton={true}
            dismissibleSnackbar={true}
            dismissibleSnackbarTimer={
                props.dismissibleSnackbarTimer || SNACKBAR_DISMISS_TIMER
            }
        />
    );
}

export default RidesSnackbar;
